import { useEffect } from 'react';

interface SEOProps {
  jsonLd: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export { SITE_URL };

export default function SEO({ jsonLd }: SEOProps) {
  useEffect(() => {
    const id = `jsonld-${Math.random().toString(36).slice(2)}`;
    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(Array.isArray(jsonLd) ? jsonLd : jsonLd);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById(id);
      if (existing) document.head.removeChild(existing);
    };
  }, []);

  return null;
}
